<template>
  <div>
    <Head title="Blocks" />
    <h1 class="mb-8 text-3xl font-bold">Blocks</h1>
    <div class="flex items-center mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/>
    </div>
    <div class="flex items-center justify-between mb-6">
      <a
        v-if="(blocks.data.length > 0 && url())"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/blocks/download${url()}`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Production Date</th>
          <th class="pb-4 pt-6 px-6">Block ID</th>
          <th class="pb-4 pt-6 px-6">Block Category</th>
          <th class="pb-4 pt-6 px-6">Block Type</th>
          <th class="pb-4 pt-6 px-6">Dimension</th>
          <th class="pb-4 pt-6 px-6">Block Weight</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Status</th>
        </tr>
        <tr
          v-for="block in blocks.data"
          :key="block.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.block }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.category }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.type }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.dimension }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.weight }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="editUrl(block)">
              {{ block.status }}
            </Link>
          </td>
          <td v-if ="role == 'admin' || role == 'manager'" class="w-px border-t">
            <a :href="editUrl(block)" class="flex items-center justify-end pr-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="blocks.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="9">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="blocks.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination' 

export default {
  components: {
    Head,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination
  },
  layout: Layout,
  props: {
    filters: Object,
    blocks: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue,
        status: this.filters.status,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/blocks/uncut', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    editUrl(ele) {
      let url = '#'
      if (this.role == 'admin' || this.role =='manager') {
        url = `/blocks/${ele.id}/edit`
      }
      return url
    },
    url() {
      let query = '';
      if (this.form.search) {
        query += `search=${this.form.search}`;
      }
      if (this.form.skuType) {
        if (query) {
          query += '&';
        }
        query += `status=${this.form.status}`;
      }
      if (this.form.dateValue) {
        if (query) {
          query += '&';
        }
        query += `dateValue=${this.form.dateValue}`;
      }
      if (query) {
        query = `?${query}`;
      }
      return query;
    },
  },
}
</script>
